import { asyncDebounce } from 'common/helper/async/debounce';
import { AgentAutocompleteStoreEvent } from 'common/module/agent/autocomplete/store.event';
import { AutocompleteResultInterface } from 'common/module/autocomplete/result.interface';
import { AutocompleteSectionInterface } from 'common/module/autocomplete/section.interface';
import { AutocompleteStoreEvent } from 'common/module/autocomplete/store.event';
import { AutocompleteStoreInterface } from 'common/module/autocomplete/store.interface';
import { AutocompleteStoreDecorator } from 'common/module/autocomplete/store/decorator';
import { BuildingReviewAutocompleteStoreEvent } from 'desktop/module/building-review/autocomplete/store.event';
import { BuildingReviewAutocompleteStoreDecoratorInterface } from 'desktop/module/building-review/autocomplete/store-decorator.interface';

export class BuildingReviewAutocompleteStoreDecorator
  extends AutocompleteStoreDecorator
  implements BuildingReviewAutocompleteStoreDecoratorInterface
{
  /**
   * @inheritDoc
   */
  public search: (searchString: string) => void;

  /**
   * @inheritDoc
   */
  constructor(autocompleteStore: AutocompleteStoreInterface) {
    super(autocompleteStore);

    // debounce search
    this.search = asyncDebounce((searchString: string) => {
      this.autocompleteStore.searchLocations(searchString, {
        'filter[full_name]': searchString,
        'filter[is_leaf]': '1',
        'page[limit]': 10,
      });
      this.autocompleteStore.getEventEmitter().emit(AgentAutocompleteStoreEvent.searchStart, searchString);
    }, 100);

    this.autocompleteStore
      .getEventEmitter()
      .addListener(AutocompleteStoreEvent.searchLocationsSuccess, this.onSearchLocationsSuccess);
  }

  /**
   * @inheritDoc
   */
  public getAutocompleteResults(): AutocompleteSectionInterface[] {
    const autocompleteStoreState = this.autocompleteStore.getState();
    const autocompleteResults: AutocompleteSectionInterface[] = [];

    if (autocompleteStoreState.locations && autocompleteStoreState.locations.length) {
      autocompleteResults.push({
        id: '1',
        name: '',
        suggestions: autocompleteStoreState.locations.map((location) => ({
          id: location.id,
          text: location.name,
          description: location.path_name,
          sectionId: '1',
        })),
      });
    }

    return autocompleteResults;
  }

  /**
   * @inheritDoc
   */
  public setResult(result: AutocompleteResultInterface): void {
    this.autocompleteStore.setLocationId(result.id);
  }

  /**
   * Triggers when locations found
   */
  private onSearchLocationsSuccess = () => {
    this.autocompleteStore.getEventEmitter().emit(BuildingReviewAutocompleteStoreEvent.searchSuccess);
  };
}
